export default __webpack_public_path__ + "static/media/NGORealCase2-en.e31c0451.jpg";